import { I18nEnum } from "@/shared/lib/i18n/i18n.types"
import { isDev } from "@/shared/lib/env/env"
import { LANGUAGE_KEY } from "@/shared/lib/storage/device-preference"
import i18n, { Resource } from "i18next"
import { initReactI18next } from "react-i18next"
import * as en from "./en"
import * as ja from "./ja"
import * as ko from "./ko"

const resources: Resource = {
  en: {
    translation: en,
  },
  ko: {
    translation: ko,
  },
  ja: {
    translation: ja,
  },
} as const

const SUPPORTED_LANGUAGES = [I18nEnum.Ko, I18nEnum.En, I18nEnum.Ja] as const

const detectLanguage = (): string => {
  try {
    const savedLanguage = localStorage.getItem(LANGUAGE_KEY)
    if (
      savedLanguage &&
      SUPPORTED_LANGUAGES.includes(savedLanguage as I18nEnum)
    ) {
      if (isDev) {
        console.log("언어 감지 - localStorage에서:", savedLanguage)
      }
      return savedLanguage
    }
  } catch (error) {
    // localStorage 접근 실패 시 브라우저 언어로 fallback
    if (isDev) {
      console.warn("localStorage 접근 실패:", error)
    }
  }

  const browserLanguage = navigator.language
  if (isDev) {
    console.log("언어 감지 - navigator.language:", browserLanguage)
  }

  if (browserLanguage.startsWith("en")) return "en"
  if (browserLanguage.startsWith("ko")) return "ko"
  if (browserLanguage.startsWith("ja")) return "ja"

  // 기본값
  return "ko"
}

const detectedLanguage = detectLanguage()

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: detectedLanguage,
    fallbackLng: "ko",
    interpolation: {
      escapeValue: false,
    },
    compatibilityJSON: "v3",
  })
  .then(() => {
    try {
      localStorage.setItem(LANGUAGE_KEY, i18n.language)
    } catch (error) {
      console.warn("localStorage 저장 실패:", error)
    }
  })
  .catch((error) => {
    console.error("i18n 초기화 실패:", error)
  })

i18n.on("languageChanged", (lng: string) => {
  if (isDev) {
    console.log("언어 변경됨:", lng)
  }
  try {
    localStorage.setItem(LANGUAGE_KEY, lng)
  } catch (error) {
    console.warn("언어 변경 시 localStorage 저장 실패:", error)
  }
})

export default i18n
